<template>
  <aside
    v-show="$utils.showAsideNavigationMenu"
    :class="['o-edition-section-navigation', $store.getters.getIsClientData === false
      ? 'o-edition-section-content-navigation' : '']"
  >
    <MoleculeEditionSectionNavigationMenu/>
  </aside>
</template>

<script>
export default {
  name: 'OrganismEditionSectionNavigation',

  components: {
    MoleculeEditionSectionNavigationMenu: () => import('@/components/molecules/MoleculeEditionSectionNavigationMenu')
  }
}
</script>
